





























import Vue from "vue";
import login from "@/components/FormLogin.vue";
import HelloWorld from "./components/HelloWorld.vue";
import bus from "@/main";
import Navbar from "@/components/Navbar.vue";
export default Vue.extend({
  name: "App",

  components: {
    HelloWorld,
    Navbar,
    login
  },

  mounted() {
    this.cekStatus();
    bus.$on("authChanged", () => {
      this.cekStatus();
    });
  },

  methods: {
    cekStatus: function() {
      this.isLogin = this.$store.getters.isLogin;
      console.log(this.$route.name);
      if (this.isLogin) {
        // parsing data
        if (this.$route.name == "home") {
          this.$router.replace("/dashboard");
        }
      } else {
        if (this.$route.name !== "home") {
          this.$router.replace("/");
        }
      }
    }
  },

  data: () => ({
    isLogin: false
  })
});
